import { Component, Output, EventEmitter, Input, OnInit, TemplateRef, viewChild } from '@angular/core';
import { IrisButtonTypes } from '@sondermind/iris/button';

@Component({
  selector: 'client-insurance-review',
  templateUrl: './insurance-review.component.html',
  styleUrls: ['./insurance-review.component.scss'],
  standalone: false
})
export class InsuranceReviewComponent implements OnInit {
  @Input() isMobile: boolean;
  @Input() useInSessionRequest: boolean = false;
  @Input() isEAP: boolean;
  @Input() fromDirectBooking: boolean = false;
  @Output() closeReview: EventEmitter<void> = new EventEmitter<void>();

  // Template for the action button that parent component can render
  readonly actionButtonTemplate = viewChild.required<TemplateRef<unknown>>('actionButton');

  reviewParagraphText: string = '';
  IrisButtonTypes = IrisButtonTypes;
  ngOnInit() {
    this.reviewParagraphText = this.isEAP
      ? 'We still weren’t able to verify your EAP information. Someone from our team may reach out to you for more information.'
      : 'We still weren’t able to verify your insurance information. Your insurance card will be manually reviewed by someone from our team. They may reach out to you for more information.';
  }

  confirm(): void {
    this.closeReview.emit();
  }
}
